/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2018,2019. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/*
 * Application Constants
 */
var resources = {
  appeals: 'v1/ua/appeals',
  appealsForm: 'v1/ua/appeals_form',
  applications: 'v1/ua/applications',
  applicationForm: 'v1/ua/application_form',
  applicationFormOwnership: 'v1/ua/application_form_ownership',
  caseContacts: 'v1/ua/case_contacts',
  draftApplications: 'v1/ua/draft_applications',
  login: 'v1/ua/login',
  messages: 'v1/ua/messages',
  organisation: 'v1/ua/organisation',
  profile: 'v1/ua/profile',
  submissionForm: 'v1/ua/submission_form',
  submittedApplications: 'v1/ua/submitted_applications',
  userAccount: 'v1/ua/user_account',
  generatedUserAccount: 'v1/ua/generated_user_accounts',
  userAccountLogin: 'v1/ua/user_account_login',
  onlineCategories: 'v1/ua/online_categories',
  withdrawRequestReasons: 'v1/ua/withdraw_request_reasons',
  withdraw: 'v1/ua/withdraw',
  ssoVerifier: 'v1/ua/sso_verifier',
  systemConfigurations: 'v1/ua/system_configurations',
  icon: 'v1/ua/app_image_resource?resourceName=',
  screeningForm: 'v1/ua/screening_form',
  lifeEventsForm: 'v1/ua/life_events_form',
  filteredScreeningForm: 'v1/ua/filter_screening_form',
  form: 'v1/ua/form',
  lifeEventCategories: 'v1/ua/life_event_categories',
  lifeEventsHistory: 'v1/ua/life_events_history',
  lifeEventsRemoteSystems: 'v1/ua/life_event_remote_systems'
};
export default resources;